import React from 'react';
import healthcare1 from '../images/bluebox1.png';
import healthcare2 from '../images/bluebox2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function BlueBoxMedia() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">Blue Box Media</span> – Influencer Marketing Growth Powered by Peregrinee
                    </div>
                </div>
            </section>

            <section className="container my-5">

                {/* Section 1 */}
                <div className="row g-0 overflow-hidden shadow rounded">

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Blue Box Media Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">

                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Blue Box Media</span> – Building a Scalable Brand Outreach & Sales Pipeline
                        </h1>

                        <p className="mb-3 ps-1">
                            Blue Box Media is an influencer marketing and creator collaboration agency helping consumer brands grow through impactful influencer campaigns, social media engagement, and creator partnerships.
                        </p>

                        <p className="mb-3 ps-1">
                            The agency has worked with well-known brands including Pantene, Plum, and several fast-growing lifestyle and beauty companies across India.
                        </p>

                        <p className="mb-3 ps-1">
                            As Blue Box Media started scaling operations, the need for a structured business development process became increasingly important. While the agency had strong campaign execution capabilities, there was no predictable outbound system generating continuous brand conversations.
                        </p>

                        <p className="mb-3 ps-1 fw-bold">
                            <span className="highlight-orange">Key Business Challenges:</span>
                        </p>

                        <p className="mb-2 ps-3">
                            Lack of a consistent lead generation and sales outreach process.
                        </p>

                        <p className="mb-2 ps-3">
                            No centralized pipeline to track ongoing brand conversations and partnerships.
                        </p>

                        <p className="mb-2 ps-3">
                            Difficulty reaching larger consumer brands and decision-makers at scale.
                        </p>

                        <p className="mb-2 ps-3">
                            Outbound outreach efforts were fragmented and manually managed.
                        </p>

                        <p className="mb-4 ps-1">
                            To solve these growth bottlenecks, Peregrinee partnered with Blue Box Media to build a structured multi-channel outbound growth engine focused on generating qualified brand meetings and long-term partnership opportunities.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>

                    </div>
                </div>

                {/* Section 2 */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">

                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> Blue Box Media
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Industry</h4>
                        <p className="mb-3 ps-3">
                            Influencer Marketing, Creator Partnerships & Brand Collaborations
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Services Provided By Peregrinee</h4>
                        <p className="mb-3 ps-3">
                            Sales Pipeline Development, Multi-Channel Cold Outreach, LinkedIn Outreach,
                            Email Outreach Automation, CRM Structuring, Lead Qualification,
                            Meeting Booking Systems, Brand Prospecting & Outreach Strategy
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Target Outreach</h4>
                        <p className="mb-3 ps-3">
                            Consumer Brands, Beauty Brands, D2C Companies, Lifestyle Businesses,
                            FMCG Startups, Marketing Teams & Brand Partnership Decision-Makers
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Nature</h4>
                        <p className="mb-3 ps-3">
                            Continuous Ongoing Growth & Business Development Partnership
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Peregrinee Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            Growth Strategists, Outreach Specialists, CRM Consultants,
                            Sales Pipeline Architects & Lead Generation Team
                        </p>

                        <p className="mb-4 ps-3">
                            Peregrinee designed and implemented a structured outbound sales system
                            specifically tailored for influencer marketing and brand partnership acquisition.
                            <br /><br />

                            The primary focus was to help Blue Box Media consistently connect with
                            larger brands through personalized multi-channel outreach campaigns using
                            LinkedIn and cold email strategies.
                            <br /><br />

                            Instead of relying only on referrals or inconsistent inbound opportunities,
                            the agency now operates with a scalable outreach infrastructure capable of
                            generating predictable business conversations every month.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>

                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Blue Box Media Campaign Dashboard"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                </div>

                {/* Section 3 */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Blue Box Media Growth Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">

                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Our Solution & Impact</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Peregrinee built a dedicated outbound sales and brand acquisition workflow
                            for Blue Box Media focused on generating high-quality brand conversations
                            through consistent multi-channel outreach.
                        </p>

                        <p className="mb-3 ps-1">
                            The outreach process combines personalized cold email campaigns,
                            LinkedIn networking strategies, lead qualification systems,
                            and structured follow-up workflows to maximize response rates
                            and meeting conversions.
                        </p>

                        <p className="mb-3 ps-1">
                            Along with outreach execution, we also developed a centralized sales pipeline
                            enabling the Blue Box Media team to efficiently track leads,
                            conversations, meetings, and partnership opportunities.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">
                            Key Results & Ongoing Outcomes
                        </h4>

                        <ul className="ps-3 mb-4">

                            <li className="mb-1">
                                Successfully booked sales meetings with multiple high-potential consumer brands
                            </li>

                            <li className="mb-1">
                                Connected Blue Box Media with larger brand decision-makers and partnership teams
                            </li>

                            <li className="mb-1">
                                Built a scalable multi-channel outreach engine using LinkedIn and email
                            </li>

                            <li className="mb-1">
                                Established a structured and trackable sales pipeline for ongoing growth
                            </li>

                            <li className="mb-1">
                                Improved outreach consistency, response management, and follow-up systems
                            </li>

                            <li className="mb-1">
                                Enabled continuous lead generation and brand partnership opportunities
                            </li>

                        </ul>

                        <p className="mb-4 ps-1">
                            This collaboration continues as an ongoing growth partnership where Peregrinee
                            actively supports Blue Box Media in expanding its outreach network,
                            generating qualified sales opportunities, and scaling brand acquisition efforts.
                            <br /><br />

                            By combining strategy, outreach automation, pipeline management,
                            and personalized communication systems, Blue Box Media now operates
                            with a far more predictable and scalable business development process.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>

                    </div>
                </div>

                <OurPartner />

            </section>
        </>
    );
}

export default BlueBoxMedia;